export const VNDataBridgeReceiveType = {
  VN_UPDATE_CART: 'VN_UPDATE_CART',
  VN_CFD_SCREEN_NAV: 'VN_CFD_SCREEN_NAV',
  VN_EXECUTE_SALES_REQUEST: 'VN_EXECUTE_SALES_REQUEST',
  VN_EXECUTE_AUTH_REQUEST: 'VN_EXECUTE_AUTH_REQUEST',
  VN_EXECUTE_REFUND_REQUEST: 'VN_EXECUTE_REFUND_REQUEST',
  VN_PRINT_RECEIPT: 'VN_PRINT_RECEIPT',
  VN_INITIALIZE_CFD: 'VN_INITIALIZE_CFD',
  VN_SEND_DEVICE_CONFIG: 'VN_SEND_DEVICE_CONFIG', // POS -> CFD
  VN_RESET_CFD: 'VN_RESET_CFD',
  VN_TRANSACTION_RESULT: 'VN_TRANSACTION_RESULT',
  VN_TRANSACTION_RECOVERY: 'VN_TRANSACTION_RECOVERY', // Resume transaction after WIN Death from Android
  VNCFD_USER_PAYMENT_PROGRESS: 'VNCFD_USER_PAYMENT_PROGRESS',
  RETRY_PAYMENT: 'RETRY_PAYMENT', // POS -> CFD
  VN_ORDER_UPDATE: 'VN_ORDER_UPDATE', //POS -> CFD
  VN_DEVICE_ID: 'VN_DEVICE_ID',
  VN_VOID_TRANSACTION: 'VN_VOID_TRANSACTION', // confirmation that Android has received the request to void
  VN_PRINT_STATUS: 'VN_PRINT_STATUS', // POS => CFD
  VN_DEVICE_PAIRING_RESULT: 'VN_DEVICE_PAIRING_RESULT', // ANDROID -> CFD / POS
  VN_CFD_COMM_STATE: 'VN_CFD_COMM_STATE', // ANDROID -> CFD / POS APK v2.20+
  VN_CFD_WEB_VIEW_LOADED: 'VN_CFD_WEB_VIEW_LOADED', // CFD => Pos
  VN_RECEIPT_MESSAGE: 'VN_RECEIPT_MESSAGE', // incoming receipt message
  VN_ENABLE_LOG_PASSTHROUGH: 'VN_ENABLE_LOG_PASSTHROUGH', // incoming LOG
  VN_LOG_PASSTHROUGH: 'VN_LOG_PASSTHROUGH', // incoming message
  VN_BUILD_INFO: 'VN_BUILD_INFO', // ANDROID -> POS
}

export default VNDataBridgeReceiveType
